import { render } from "./UpdateTestees.vue?vue&type=template&id=a61962e2&scoped=true"
import script from "./UpdateTestees.vue?vue&type=script&lang=js"
export * from "./UpdateTestees.vue?vue&type=script&lang=js"

import "./UpdateTestees.vue?vue&type=style&index=0&id=a61962e2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a61962e2"

export default script